<template>
  <v-card class="bg-transparent h-screen overflow-visible" flat :style="ActiveComponent == WidgetList.AIChatBot ? '' : ''">
    <ChatOverview></ChatOverview>
  </v-card>
</template>

<script lang="ts" setup>
import { useGlobalStore } from '../store/globalStore';
import {WidgetList} from '../constants/common-constants'

const {ActiveComponent} = useGlobalStore()
</script>